const myDatabaseConfig = {
    type: "DatabaseConfig",
    Name: "myDatabase",
    mySqlUrlorIp: "dmddomy.pl",
    apiPort: 5000
  };
  
  export default myDatabaseConfig;
